var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _path6, _path7, _ellipse, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_818",
    "data-name": "Group 818",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.301,
    height: 70.301,
    viewBox: "0 0 70.301 70.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 35.15,
    cy: 35.15,
    r: 35.15,
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 34.407,
    cy: 34.407,
    r: 34.407,
    transform: "translate(0.813 0.519)",
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M575.136,675.165c0,11.447-8.223,17.079-18.9,17.079s-19.764-5.632-19.764-17.079,8.656-20.725,19.333-20.725S575.136,663.709,575.136,675.165Z",
    transform: "translate(-520.986 -636.848)",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M556.247,795.655a34.246,34.246,0,0,0,18.917-5.66c-1.268-6.928-6.093-7.325-6.093-7.325H542.465s-4.55.373-5.975,6.749A34.25,34.25,0,0,0,556.247,795.655Z",
    transform: "translate(-521 -726.185)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M373.469,683h10.643v8.514a5.32,5.32,0,0,1-5.332,5.329h0a5.32,5.32,0,0,1-5.32-5.32V683Z",
    transform: "translate(-343.942 -634.974)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M374.482,681.723h8.611a1.016,1.016,0,0,1,1.016,1.016v7.5a5.32,5.32,0,0,1-5.329,5.32h0a5.32,5.32,0,0,1-5.32-5.32v-7.5a1.016,1.016,0,0,1,1.016-1.016Z",
    transform: "translate(-343.942 -634.083)",
    fill: "#fda57d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M582.84,765.127a15.317,15.317,0,0,0,10.643.03V763.85H582.84Z",
    transform: "translate(-553.292 -713.073)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.633 22.257)",
    fill: "#fda57d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M542.48,682.931a27.356,27.356,0,0,0,16.682-10.361s9.5,10.458,16.118,9.305c0,0,3.837-4.031,0-8.059s-6.812-9.114-11.9-8.444-11.323.958-14.007,3.358S542.48,682.931,542.48,682.931Z",
    transform: "translate(-525.173 -644.423)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M542.48,682.3a27.356,27.356,0,0,0,16.682-10.361s9.5,10.458,16.118,9.305c0,0,3.837-4.031,0-8.059s-6.812-9.114-11.9-8.444-11.31.946-13.995,3.373S542.48,682.3,542.48,682.3Z",
    transform: "translate(-525.173 -643.984)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(18.208 34.838)",
    fill: "#fda57d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(48.717 34.838)",
    fill: "#fda57d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.949b4eb17a8cf0ec68dd527d0194e315.svg";
export { ForwardRef as ReactComponent };